import { createRoot } from 'react-dom/client';
import makeMainRoutes from './lib/routes';
import createMsalInstance from './lib/msalConfig';
import api from './lib/api';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

api.getPublicConfig()
  .then(({ msClientId, msTenantId }) => {
    const msalInstance = createMsalInstance({ msClientId, msTenantId });
    root.render(makeMainRoutes(msalInstance));
  });
